import React from 'react';
interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
}
export function Logo({
  className = '',
  size = 'md',
  variant = 'dark'
}: LogoProps) {
  const sizes = {
    sm: {
      icon: 'w-6 h-6',
      text: 'text-lg',
      gap: 'gap-2'
    },
    md: {
      icon: 'w-8 h-8',
      text: 'text-xl',
      gap: 'gap-2.5'
    },
    lg: {
      icon: 'w-10 h-10',
      text: 'text-2xl',
      gap: 'gap-3'
    }
  };
  const s = sizes[size];
  const iconColor = variant === 'light' ? 'text-blue-400' : 'text-blue-600';
  const textColor1 = variant === 'light' ? 'text-white' : 'text-gray-900';
  const textColor2 = variant === 'light' ? 'text-white' : 'text-blue-600';
  return <div className={`flex items-center ${s.gap} ${className}`} data-id="element-151">
      {/* House Icon */}
      <svg className={`${s.icon} ${iconColor}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-152">
        <path d="M3 10l9-7 9 7" data-id="element-153" />
        <path d="M4 10v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10" data-id="element-154" />
        <path d="M10 22V12h4v10" data-id="element-155" />
        <path d="M18 4v4" data-id="element-156" />
      </svg>

      {/* Wordmark */}
      <div className="flex flex-col justify-center leading-none" data-id="element-157">
        <span className={`${s.text} font-bold tracking-tight ${textColor1}`} data-id="element-158">
          MORTGAGE
        </span>
        <span className={`${s.text} font-bold tracking-tight ${textColor2}`} data-id="element-159">
          DEPOT
        </span>
      </div>
    </div>;
}